export default __webpack_public_path__ + "static/media/kwiaty.0a29b78a.svg";